import { Component, OnInit } from '@angular/core';
import { AffiliateProgramService } from 'src/app/api/affiliate-program.service';
import { AuthService } from 'src/app/api/auth.service';
import { MetadataService } from 'src/app/api/metadata.service';
import { ProfileService } from 'src/app/api/profile.service';
import { Coin } from 'src/app/models/coin';

@Component({
  selector: 'app-affiliate-program',
  templateUrl: './affiliate-program.component.html',
  styleUrls: ['./affiliate-program.component.scss']
})
export class AffiliateProgramComponent implements OnInit {
  readonly FALLBACK_CURRENCY = 'AED';
  fiatCurrency: string;
  reward: Coin;

  constructor(
    private authService: AuthService,
    private metadata: MetadataService,
    private affiliateProgramService: AffiliateProgramService
  ) { }

  ngOnInit() {
    this.getUserDefaultCurrency();
  }

  getHighestReward() {
    this.affiliateProgramService.getAffiliateSteps(this.fiatCurrency).subscribe(response => {
      this.reward = response && response[response.length - 1] ? response[response.length - 1].reward : null;
    });
  }

  getUserDefaultCurrency() {
    this.metadata.userCurrency().subscribe(response => {
      this.fiatCurrency = response;
      this.getHighestReward();
    }, err => {
      this.fiatCurrency = this.FALLBACK_CURRENCY;
    })
  }

  get isLoggedIn() {
    return this.authService.getToken() !== null;
  }
}
